<template>
  <div id="payments-container">
    <div class="print-only box-image" :style="background_color">
      <img class="print-only image" :src="user.event_logo" />
    </div>

    <Header
      :page="'payments'"
      :title_one="'payments_and_budget'"
      :action_one="'print'"
      @print="print()"
      :banner_docsok_msg="doc_ok"
    ></Header>

    <div v-if="person != undefined" class=" print-only title-team">
      {{ person.name }} {{ person.surname }}
    </div>
    <div v-else-if="team.team" class=" print-only title-team">
      {{ team.team.name ? team.team.name : team.club.name }} ({{
        team.team.category.max_age
      }})
    </div>
    <div v-else-if="selectedClubTeam" class="print-only title-team">
      {{ selectedClubTeam.name || club.name }}
      ({{ selectedClubTeam.category.name }})
    </div>

    <div id="empty-space"></div>
    <template v-if="event.type_id == 1">
        <p  class="note" v-html="$t('finances.tourist_tax_note')"></p>
        <div class="bank-info-title">{{ $t('finances.bank_info.title') }}</div>
        <div class="bank-info">
            <div><span class="label">{{ $t('finances.bank_info.cc') }}</span> 2100 4535 67 2200028392</div>
            <div><span class="label">{{ $t('finances.bank_info.iban') }}</span> ES83 2100 4535 67 2200028392</div>
            <div><span class="label">{{ $t('finances.bank_info.swift') }}</span> CAIXESBBXXX</div>    
            <div><span class="label">{{ $t('finances.bank_info.entity') }}</span> CaixaBank SA </div>
            <div><span class="label">{{ $t('finances.bank_info.proprietary') }}</span> AE MICFOOTBALL</div>
            <div><span class="label">{{ $t('finances.bank_info.address') }}</span> Rambla Catalunya 78, 43500, Tortosa, España</div>
        </div>
        <div style="margin-top: 10px;">{{ $t('finances.bank_info.note') }}</div>
    </template>

    <div id="empty-space"></div>

    <template v-if="budget_visible != 0">
      <span class="page-title">{{ $t("titles.budget") }}</span>
      <!-- BUDGET -->
      <v-data-table
        v-if="budget_visible != 0"
        id="budget"
        :headers="budget_headers"
        :items="budget"
        :no-data-text="''"
        :no-results-text="''"
        :hideActions="true"
      >
        <template v-slot:items="props">
          <tr :class="{ total: props.item.is_total }">
            <td v-if="props.item.is_category" colspan="5" class="category">
              {{ props.item.name }}
            </td>
            <template v-else>
              <td>
                <template v-if="!props.item.is_total">{{
                  props.item.name
                }}</template>
              </td>
              <td>
                <template v-if="!props.item.is_total">{{
                  props.item.description
                }}</template>
              </td>

              <td v-if="props.item.edit">
                <input class="input" type="number" v-model="quantity_edit" />
              </td>
              <td v-else>
                {{
                  props.item.type != 2 || props.item.quantity != 1
                    ? props.item.units
                    : ""
                }}
              </td>
              <td v-if="!props.item.is_total">
                {{ props.item.unitprice | toMoney }}
              </td>
              <td v-else :class="{ label: props.item.is_total }">
                {{ props.item.name }}
              </td>
              <td :class="{ value: props.item.is_total }">
                {{ props.item.import | toMoney }}
              </td>
            </template>
          </tr>
        </template>
      </v-data-table>
    </template>

    <!-- PAYMENTS -->

    <template
      v-if="
        $route.name == 'campus_payments' &&
          parseInt(budget_total) - parseInt(payments_total) > 0
      "
    >
      <div class="row" id="campus_payments">
        <span class="page-title">{{ $t("titles.payments") }}</span>
        <button class="mainButton" @click="go_to_redsys">
          {{ $t("params.pay") }}
        </button>
      </div>
    </template>
    <template v-else>
      <span class="page-title">{{ $t("titles.payments") }}</span>
    </template>

    <v-data-table
      id="payments"
      :headers="payment_headers"
      :items="payments"
      :no-data-text="''"
      :no-results-text="''"
      :hideActions="true"
    >
      <template v-slot:items="props">
        <td>{{ $t(props.item.transaction.mode) }}</td>
        <td>{{ props.item.transaction.date }}</td>
        <td>{{ props.item.transaction.affair }}</td>
        <td>{{ props.item.import | toMoney }}</td>
      </template>
    </v-data-table>

    <!-- SUMMARY -->
    <table id="total-summary">
      <tr>
        <th colspan="3" class="empty"></th>
      </tr>
      <tr class="row">
        <td width="300px" class="empty"></td>
        <td class="label">{{ $t("finances.budget.received") }}</td>
        <td class="value" width="225px">{{ payments_total | toMoney }}</td>
      </tr>
      <tr class="row" v-if="budget_total">
        <td width="300px" class="empty"></td>
        <td class="label">{{ $t("finances.budget.remaining") }}</td>
        <td class="value" width="225px">
          {{
            (budget_total - payments_total >= 0
              ? budget_total - payments_total
              : 0) | toMoney
          }}
        </td>
      </tr>
      <tr
        class="row exceeded"
        v-if="budget_total && payments_total > budget_total"
      >
        <td width="300px" class="empty"></td>
        <td class="label">{{ $t("finances.budget.exceeded") }}</td>
        <td class="value" width="225px">
          {{ Math.abs(budget_total - payments_total) | toMoney }}
        </td>
      </tr>
    </table>
    
  </div>
</template>

<script>
/* global ObjectToArray */
import i18n from '@/i18n'
import Header from '@/components/layout/Header'

export default {
  name: 'payments',

  components: {
    Header
  },

  data () {
    return {
      background_color:
        'background: ' + this.$store.getters['user/getUser'].event_color + ';'
    }
  },

  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event() {
        return this.$store.getters.getCurrentEvent();
    },

    team() {
      return this.$store.getters["team/getTeam"];
    },

    club () {
      return this.$store.getters['club/getClub']
    },

    selectedClubTeam () {
      const teamId = this.$route.params.team_id
      return this.club && this.club.teams && this.club.teams[teamId] ? this.club.teams[teamId] : null
    },

    budget_headers () {
      return [
        {
          text: i18n.t('params.affair'),
          value: 'name',
          sortable: false
        },
        {
          text: i18n.t('params.description'),
          value: 'description',
          sortable: false
        },
        {
          text: i18n.t('params.quantity'),
          value: 'units',
          sortable: false
        },
        {
          text: i18n.t('params.unit_price'),
          value: 'units',
          sortable: false
        },
        {
          text: i18n.t('params.import'),
          value: 'import',
          sortable: false,
          width: '215px'
        }
      ]
    },

    payment_headers () {
      return [
        {
          text: this.$t(`params.payment_type`),
          value: 'transaction.type',
          sortable: false
        },
        {
          text: this.$t(`params.date_id`),
          value: 'transaction.date',
          sortable: false
        },
        {
          text: this.$t(`params.affair`),
          value: 'transaction.affair',
          sortable: false
        },
        {
          text: this.$t(`params.import`),
          value: 'import',
          sortable: false,
          width: '225px'
        }
      ]
    },

    budget () {
      var aBudgetData = []
      var aServicesTypeList = ObjectToArray(this.$store.state.service_type)
      var oBudget = this.$store.getters[`finance/getBudget`]
      var aDiscounts = []

      if (
        oBudget &&
        (oBudget.visible === 1 || oBudget.visible === '1') &&
        Object.keys(oBudget.services).length > 0
      ) {
        aServicesTypeList.forEach(serviceType => {
          var serviceTypeAdded = false
          if (oBudget.services) {
            oBudget.services.forEach(service => {
              if (service.service_id) {
                var oService = this.$store.getters['finance/get_service_by_id'](
                  service.service_id
                )

                if (
                  typeof oService !== 'undefined' &&
                  String(oService.type) === String(serviceType.id)
                ) {
                  if (!serviceTypeAdded) {
                    serviceTypeAdded = true
                    aBudgetData.push({
                      is_category: true,
                      name: i18n.t(serviceType.name)
                    })
                  }

                  aBudgetData.push({
                    id: service.id,
                    name: i18n.t(oService.name),
                    description: i18n.t(oService.description),
                    units: service.quantity,
                    unitprice: service.import / service.quantity,
                    import: service.import,
                    type: 1, // oService.type,
                    edit: service.edit
                  })
                }
              } else if (service.discount_id) {
                var oDiscount = this.$store.getters[ 'finance/get_discount_by_id' ](service.discount_id)
                if (String(oDiscount.type) === String(serviceType.id)) {
                  aDiscounts.push({
                    id: service.id,
                    name: i18n.t(oDiscount.name),
                    description: i18n.t(oDiscount.description),
                    units: service.quantity,
                    import: service.import,
                    type: 2, // oService.type
                    edit: service.edit
                  })
                }
              }
            })
          }
        })

        if (aDiscounts.length > 0) {
          aBudgetData.push({
            is_category: true,
            name: i18n.t('finances.discounts.label')
          })
          aDiscounts.forEach(discount => {
            aBudgetData.push({
              id: discount.id,
              name: discount.name,
              description: discount.description,
              units: discount.units,
              unitprice: discount.import / discount.units,
              import: discount.import,
              type: discount.type, // oService.type
              edit: discount.edit
            })
          })
        }

        // ADDED TOTAL BUDGET
        aBudgetData.push({
          is_total: true,
          name: 'Total',
          import: oBudget.total
        })
      }

      return aBudgetData
    },

    payments () {
      var path = `finance/getPaymentsCard`
      var payments = {
        ...this.$store.getters[path]
      }
      var result = []
      for (const key in payments) {
        result.push(payments[key])
      }
      return result
    },

    payments_total () {
      var total = 0

      for (const key in this.payments) {
        total += parseFloat(this.payments[key].import)
      }

      return total
    },

    budget_total () {
      var oBudget = this.$store.getters[`finance/getBudget`]
      return oBudget.total
    },

    budget_visible: {
      get () {
        var oBudget = this.$store.getters[`finance/getBudget`]
        return oBudget.visible
      },
      set () {}
    },

    person () {
      return this.$store.getters['person/getPerson']
    },

    doc_ok () {
      let person = this.$store.getters['person/getPerson']
      if (
        person &&
          ((!person.antithermal && [4, 5].includes(this.event.type_id)) ||
          !person.medicines ||
          !person.externals ||
          !person.image_right)) {
          return false
        }
        return true
    }
  },

  methods: {
    load () {
      var self = this

      if (this.user.team_id) {
        this.$store
          .dispatch('team/loadTeam', { team_id: this.user.team_id })
          .then(function (team) {})
      }

      // load information for admin user
      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {})
      }

      // load information from campus
      if (this.user.event_id) {
        this.$store
          .dispatch('person/loadPersonCampus', {
            campus_id: this.user.event_id,
            participant_id: this.user.participant_id
          })
          .then(function () {})
      }

      var path = `finance/loadServices`
      var eventId =
        this.$route.name === 'campus_payments'
          ? self.user.event_id
          : self.user.event_id

      // LOAD SERVICES
      self.$store.dispatch(path, eventId).then(function () {
        // LOAD  DISCOUNTS
        path = `finance/loadDiscounts`
        self.$store.dispatch(path, eventId).then(function () {
          // LOAD BUDGET
          // campus
          if (self.$route.name === 'campus_payments') {
            self.$store
              .dispatch('finance/loadBudget', {
                entity_id: self.user.participant_id,
                type: 3,
                event_id: self.user.event_id
              })
              .then(function () {
                var oBudget = JSON.parse(
                  JSON.stringify(self.$store.getters[`finance/getBudget`])
                )
                self.budget_visible = oBudget.visible

                self.$store
                  .dispatch(
                    'finance/payments_person_card',
                    self.user.participant_id
                  )
                  .then(function () {})
              })
          } else {
            self.$store
              .dispatch('finance/loadBudget', {
                entity_id: self.$route.params.team_id,
                type: 2,
                event_id: self.user.event_id
              })
              .then(function () {
                var oBudget = JSON.parse(
                  JSON.stringify(self.$store.getters[`finance/getBudget`])
                )
                self.budget_visible = oBudget.visible

                // LOAD PAYMENT
                self.$store
                  .dispatch(
                    'finance/payments_team_card',
                    self.$route.params.team_id
                  )
                  .then(function () {})
              })
          }
        })
      })
    },

    print () {
      window.print()
    },

    go_to_redsys () {
      // check if campus
      let event = this.$store.getters.getCurrentEvent()
      if (event.is_campus) {
        let eventId = this.user.event_id
        let entityType = this.user.entity_type
        let entityId = this.user.participant_id

        window.location =
          process.env.VUE_APP_API_URL +
          `finances/${eventId}/redsys/generate/${entityType}/${entityId}?authorization=` +
          localStorage.token
      } else {
        this.$router.push({
          name: 'confirm-payment',
          params: {
            event: this.$root.formatEventUrl(event.name, event.edition)
          }
        })
      }
    }
  },

  watch: {
    $route: 'load'
  },

  created () {
    this.load()
  }
}
</script>

<style lang="scss">
.print-only {
  display: none;

  &.box-image {
    margin-bottom: 10px;
    width: calc(100%);
    height: 80px;
    overflow: auto;
    text-align: center;
  }

  &.image {
    height: calc(100% - 10px) !important;
    margin: 5px auto !important;
  }
}

#payments-container {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;

  #empty-space {
    height: 50px;
  }

  .descriptions,
  .search {
    margin-top: 25px;
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
  }

  .search {
    width: 100%;
    display: inline-block;
    input {
      @include background(
        $image: img("magnify.svg"),
        $position: right 5px center,
        $size: 22px
      );
      padding: 10px 30px 10px 15px;
      border: 1px solid $secondary-color;
      outline: none;
      font-size: 11pt;
      border-radius: 3px;
      color: $dark-color;
      float: right;

      &::placeholder {
        color: $dark-color;
        opacity: 0.5;
      }
    }
  }

  .bank-info-title {
    font-weight: bold;
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .label {
    font-weight: bold;
    margin-right: 10px;
  }

  #payments,
  #budget {
    margin-top: 20px;
  }

  #payments {
    // margin-top: 10px;

    th {
      padding: 6px 10px 0 15px !important;
    }

    .v-toolbar__title {
      color: white;
    }
    .total {
      border-top: 3px solid #828aa0;
      td {
        font-weight: bold;
        font-family: Roboto-Bold;
        padding: 15px 10px;
        font-size: 16px;
        text-transform: uppercase;
      }
    }
  }

  #budget {
    margin-bottom: 50px;

    th {
      padding: 6px 10px 0 15px !important;
      border-bottom: 0px solid #fff;
    }
    td {
      background-color: #fff;
      padding: 10px;
    }
    .v-datatable__progress {
      display: none !important;
    }
    .category {
      padding: 10px;
      background-color: #f7f7f7;
      color: #4f5462;
      text-transform: uppercase;
      font-family: AvantGarde-Bold;
    }

    .total {
      border-top: 3px solid #828aa0;
      td {
        font-weight: bold;
        font-family: Roboto-Bold;
        padding: 15px 10px;
        font-size: 16px;
        text-transform: uppercase;
      }
    }

    .input {
      border: 1px solid #ccc;
      padding: 5px 10px;
      border-radius: 3px;
      width: 75px;
    }

    .label {
      padding-right: 35px !important;
    }

    .label {
      text-align: right;
      font-size: 14px;
      text-transform: uppercase;
    }

    .value {
      font-weight: bold;
      font-family: Roboto-Bold;
      font-size: 16px;
    }
  }

  #total-summary {
    width: 100%;
    border-top: 3px solid #828aa0;
    padding-top: 10px;
    margin-bottom: 50px;

    th {
      height: 15px;
    }

    .row {
      width: 100%;
      overflow: hidden;
      padding: 5px;

      td {
        padding: 5px 24px;

        &.label {
          text-align: right;
          font-size: 14px;
          text-transform: uppercase;
        }

        &.value {
          font-weight: bold;
          font-family: Roboto-Bold;
          font-size: 16px;
        }
      }

      &.exceeded {
        td {
          &.label {
            color: #d42525;
          }

          &.value {
            color: #d42525;
          }
        }
      }
    }
  }

  #campus_payments {
    overflow: hidden;
  }

  .mainButton {
    float: right;
    width: auto;
    min-width: 40px;
    padding: 0 35px;
    outline: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    border-radius: 3px;
    // text-transform: uppercase;
    transition: all 0.5s;
    background-color: $main-color;
    color: #fff;
    height: 40px;
    margin: 0;
    margin-left: 6px;
    line-height: 40px;
    text-transform: uppercase;
    background-color: #fc8926;
    font-family: AvantGarde-Bold;
    border: 1px solid #fc8926;
    &:hover {
      background-color: #e78026;
      border-color: #e78026;
    }
  }
}

@include media("<=desktop") {
  #payments-container {
    #budget {
      td {
        padding: 5px;
      }
    }

    // #payment {
    //   td {
    //   }
    // }

    #total-summary {
      margin-top: 20px;
    }

    .label,
    .value {
      padding: 0;
      width: auto;
    }

    .empty {
      display: none;
    }
  }
}

@media print {
  .print-only {
    display: block !important;
  }

  .no-print {
    display: none !important;
  }

  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    background-color: white !important;
    // color-adjust: exact !important;
  }

  #main-content {
    height: auto !important;
    overflow: visible !important;
  }

  .mainButton {
    display: none !important;
  }

  .toogle-content {
    display: none !important;
  }

  #topbar {
    display: none !important;
  }

  #payments-container {
    #header {
      display: none;
    }

    .title-team {
      position: relative;
      top: 20px;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-family: AvantGarde-Bold;
      font-size: 28px !important;
      line-height: 40px;
      color: #222;
    }

    .left {
      padding-left: 0px !important;
    }

    .actions {
      display: none !important;
    }

    #total-summary {
      .value {
        text-align: center;
      }
    }
  }
}
</style>
